// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lx-3";
export var downloadButton = "_lx-4";
export var fileContainer = "_lx-9 _lx-7";
export var fileContainerBase = "_lx-7";
export var fileContainerFixedHeight = "_lx-8 _lx-7";
export var fileInfo = "_lx-5";
export var fileInfoWidthRestricted = "_lx-6";
export var fileType = "_lx-1";
export var fileTypeName = "_lx-2";
export var image = "_lx-0";
export var link = "_lx-b";
export var overflowEllipsis = "_lx-a";